import storeWrapper from "./src/store/storeWrapper";
import { GTMEvent } from "./src/utils/utils";

export const wrapRootElement = storeWrapper;

const transitionDelay = 750;

/**
 * shamelessly copied form https://divdev.io/animating-gatsby-pt/
 */
export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay
    );
  }
  return false;
};

export const onRouteUpdate = ({ location }) => {
  // Wrap inside a timeout to ensure the title has properly been changed
  setTimeout(() => {
    GTMEvent("pagetrigger");
  }, 250);
};

